import Vue from 'vue';
import Router from 'vue-router';
import Top from './pages/Top'
import Plan from './pages/Plan'
import NewPlan from './pages/NewPlan'
import EditPlan from './pages/EditPlan'
import Complete from './pages/Complete'
import Map from './pages/Map'
import Faq from './pages/Faq'
import CreateReservation from './pages/CreateReservation'
import Reservation from './pages/Reservation'
import TermOfFurusato from "./pages/TermOfFurusato";
import TermOfRunRun from "./pages/TermOfRunRun";
import TermOfAITaxi from "./pages/TermOfAITaxi";
import TermOfTohoku from "./pages/TermOfTohoku";

Vue.use(Router);

export default new Router({
  base: '/tohoku/',
  routes: [
    {
      path: '/termOfFurusato',
      component: TermOfFurusato,
      name: 'termOfFurusato'
    },
    {
      path: '/termOfRunRun',
      component: TermOfRunRun,
      name: 'termOfRunRun'
    },
    {
      path: '/termOfAITaxi',
      component: TermOfAITaxi,
      name: 'termOfAITaxi'
    },
    {
      path: '/termOfTohoku',
      component: TermOfTohoku,
      name: 'termOfTohoku'
    },
    {
      path: '/',
      component: Top,
      name: 'root'
    },
    {
      path: '/:lang',
      component: Top,
      name: 'top'
    },
    {
      path: '/plan/:id',
      component: Plan,
      name: 'plan'
    },
    {
      path: '/plans',
      component: Top,
      name: 'plans'
    },
    {
      path: '/plans/new',
      component: NewPlan,
      name: 'newPlan',
      props: (route) => ({
        courseId: parseInt(route.query.courseId),
        poiId: parseInt(route.query.poiId)
      })
    },
    {
      path: '/plan/edit/:id',
      component: EditPlan,
      name: 'editPlan'
    },
    {
      path: '/complete/:planId',
      component: Complete,
      name: 'complete'
    },
    {
      path: '/:lang/map/createReservation',
      component: CreateReservation,
      name: 'createReservation'
    },
    {
      path: '/:lang/map/reservation',
      component: Reservation,
      name: 'reservation'
    },
    {
      path: '/:lang/map/tag/:tagId',
      component: Map,
      name: 'mapTag'
    },
    {
      path: '/:lang/map/current/',
      component: Map,
      name: 'current'
    },
    {
      path: '/:lang/map/@:latLng?',
      component: Map,
      name: 'location'
    },
    {
      path: '/:lang/map/:poiId?',
      component: Map,
      name: 'map'
    },
    {
      path: '/faq',
      component: Faq,
      name: 'faq'
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
});
